import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { ProviderData } from '@/common/types';
import ProviderEditForm from '@/portal/routes/providers/components/ProviderEditForm.tsx';

const ProviderEditPage: React.FC = () => {
  const provider = useLoaderData() as ProviderData;

  return <ProviderEditForm provider={provider} />;
};

export default ProviderEditPage;
